<app-book-shipment-stepper
  (bookShipment)="onBookShipment($event)"
  (navigateToShipment)="onNavigateToShipment($event)"
  (cancel)="onCancel()" />

<div>
  
</div>